import { useEffect, useRef } from 'react'
import { Animated } from 'react-native'

const PULSE_DURATION_MS = 700
const PULSE_MIN_OPACITY = 0.5

/**
 * The breathing opacity every loading placeholder shares, so two skeletons on
 * screen at once pulse as one thing rather than two.
 */
export function usePulse() {
  const opacity = useRef(new Animated.Value(1)).current
  useEffect(() => {
    const loop = Animated.loop(
      Animated.sequence([
        Animated.timing(opacity, {
          toValue: PULSE_MIN_OPACITY,
          duration: PULSE_DURATION_MS,
          useNativeDriver: true,
        }),
        Animated.timing(opacity, {
          toValue: 1,
          duration: PULSE_DURATION_MS,
          useNativeDriver: true,
        }),
      ]),
    )
    loop.start()
    return () => loop.stop()
  }, [opacity])
  return opacity
}
